document.addEventListener('DOMContentLoaded', function() {
  const collectionTabs = document.querySelectorAll('.item--collection--parent');
  const fixedProductsGrids = document.querySelectorAll('.fixed-products-grid');
  const productsTabsContainer = document.querySelector('.wrapper--items--collections-tabs');
  const buildYourOwnVariantOptions = document.getElementById('build-your-own-variant-options');
  const buildYourOwnStep4 = document.getElementById('build-your-own-step-4');
  const buildYourOwnSubscriptionOptions = document.getElementById('build-your-own-subscription-options');
  const productTypeFilter = document.querySelector('.product-type-filter');

  let currentCollectionHandle = null;
  let currentFilterValue = null;

  // Helper function to get the appropriate BYO widget based on current collection
  function getCurrentByoWidget() {
    let byoWidgetContainer = null;
    
    // First, try to find a collection-specific widget
    if (currentCollectionHandle) {
      byoWidgetContainer = document.querySelector(`.byo-alternative-widget[data-byo-collection-handle="${currentCollectionHandle}"]`);
    }
    
    // Fall back to default widget if no collection-specific one found
    if (!byoWidgetContainer) {
      byoWidgetContainer = document.getElementById('current-page-product-widget');
    }
    
    return byoWidgetContainer;
  }

  // Helper function to check if current collection has BYO Bundle Product
  function hasByoBundleProductForCollection(collectionHandle) {
    if (!collectionHandle) return false;
    const byoWidget = document.querySelector(`.byo-alternative-widget[data-byo-collection-handle="${collectionHandle}"]`);
    return byoWidget !== null;
  }

  function initializeProductFilters() {
    if (!productTypeFilter) return;

    const filterScripts = document.querySelectorAll('[data-collection-filters]');
    if (filterScripts.length === 0) {
      productTypeFilter.style.display = 'none';
      return;
    }

    window.collectionFilters = {};
    filterScripts.forEach(script => {
      try {
        const data = JSON.parse(script.textContent);
        window.collectionFilters[data.collectionHandle] = data.filterValues;
      } catch (e) {
      }
    });

    if (Object.keys(window.collectionFilters).length > 0) {
      productTypeFilter.style.display = 'flex';
    }
  }

  function updateFilterTabs(collectionHandle) {
    if (!productTypeFilter || !window.collectionFilters) return;

    const filters = window.collectionFilters[collectionHandle];
    if (!filters || filters.length === 0) {
      productTypeFilter.style.display = 'none';
      return;
    }

    productTypeFilter.style.display = 'flex';
    productTypeFilter.innerHTML = '';

    filters.forEach((filterValue, index) => {
      const option = document.createElement('div');
      option.className = 'product-type-filter-option';
      const isFirst = index === 0;
      if (isFirst) {
        option.classList.add('active');
        currentFilterValue = filterValue;
      }

      option.innerHTML = `
        <input type="radio" class="filter-radio" name="product-type-filter-${collectionHandle}" ${isFirst ? 'checked' : ''}>
        <div class="filter-content">
          <div class="filter-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2"/>
              <circle cx="10" cy="10" r="5" fill="currentColor" class="filter-indicator"/>
            </svg>
          </div>
          <div class="filter-label">${filterValue}</div>
        </div>
      `;

      option.dataset.filterValue = filterValue;
      option.dataset.collectionHandle = collectionHandle;

      option.addEventListener('click', function() {
        productTypeFilter.querySelectorAll('.product-type-filter-option').forEach(opt => {
          opt.classList.remove('active');
          const radio = opt.querySelector('.filter-radio');
          if (radio) radio.checked = false;
        });
        this.classList.add('active');
        const radio = this.querySelector('.filter-radio');
        if (radio) radio.checked = true;
        currentFilterValue = filterValue;

        showGridForCollectionAndFilter(collectionHandle, filterValue);
      });

      productTypeFilter.appendChild(option);
    });
  }

  function showGridForCollectionAndFilter(collectionHandle, filterValue) {
    currentCollectionHandle = collectionHandle;
    currentFilterValue = filterValue;

    fixedProductsGrids.forEach(grid => {
      grid.style.display = 'none';
      grid.classList.remove('active');
    });

    const fixedProductDisplay = document.getElementById('fixed-product-widget-display');
    if (fixedProductDisplay) {
      const existingWidget = fixedProductDisplay.querySelector('.fixed-product-widget-container');
      if (existingWidget) {
        existingWidget.style.display = 'none';
        const originalParent = existingWidget._originalParent;
        if (originalParent && originalParent.nodeType === 1) {
          try {
            fixedProductDisplay.removeChild(existingWidget);
            originalParent.appendChild(existingWidget);
            existingWidget._originalParent = null;
          } catch (e) {
            fixedProductDisplay.removeChild(existingWidget);
          }
        } else {
          fixedProductDisplay.removeChild(existingWidget);
        }
      }
      fixedProductDisplay.style.display = 'none';
    }

    hideBuildYourOwnOptions();

    const allWidgets = document.querySelectorAll('.fixed-product-widget-container:not(#current-page-product-widget):not(.byo-alternative-widget)');
    allWidgets.forEach(w => {
      w.style.display = 'none';
    });

    const targetGrid = document.querySelector(
      `.fixed-products-grid[data-collection-handle="${collectionHandle}"][data-filter-value="${filterValue}"]`
    );

    if (targetGrid) {
      targetGrid.style.display = 'flex';
      targetGrid.classList.add('active');
      attachCardClickEvents(targetGrid);

      setTimeout(() => {
        const firstFixedCard = targetGrid.querySelector('.fixed-product-card[data-product-type="fixed"]');
        if (firstFixedCard) {
          firstFixedCard.click();
        }
      }, 100);
    }
  }

  initializeProductFilters();

  function updateVisualState(container) {
    if (!container) return;

    const variantOptions = container.querySelectorAll('.recharge-option-value');

    variantOptions.forEach(option => {
      const radio = option.querySelector('.recharge-option-value__radio');
      if (radio) {
        if (radio.checked) {
          option.classList.add('is-selected');

        } else {
          option.classList.remove('is-selected');
        }
      }
    });

    const subscriptionOptions = container.querySelectorAll('.recharge-option');

    subscriptionOptions.forEach(option => {
      const radio = option.querySelector('.recharge-option__radio');
      if (radio) {
        if (radio.checked) {
          option.classList.add('is-selected');

        } else {
          option.classList.remove('is-selected');
        }
      }
    });
  }

  function showBuildYourOwnOptions() {
    const fixedProductDisplay = document.getElementById('fixed-product-widget-display');
    if (fixedProductDisplay) {
      fixedProductDisplay.style.display = 'none';

    }

    // Find the appropriate BYO widget based on current collection
    const currentPageWidget = getCurrentByoWidget();
    if (!currentPageWidget) {

      return;
    }

    const widget = currentPageWidget.querySelector('.recharge-widget');
    if (!widget) {

      return;
    }

    // Update bundleProductId to match the BYO widget's product
    const bundleComponent = document.querySelector('choose-collection-products');
    if (bundleComponent && widget.dataset.productId) {
      bundleComponent.dataset.bundleProductId = widget.dataset.productId;
    }

    const variantOptions = widget.querySelector('.recharge-widget__variant-options');
    if (variantOptions && buildYourOwnVariantOptions) {
      buildYourOwnVariantOptions.innerHTML = variantOptions.outerHTML;
      buildYourOwnVariantOptions.style.display = 'block';

      setTimeout(() => {
        updateVisualState(buildYourOwnVariantOptions);

      }, 50);
    }

    const step4Template = document.getElementById('step-4-template');
    if (step4Template && buildYourOwnStep4) {
      const step4Content = step4Template.cloneNode(true);
      step4Content.style.display = 'block';
      step4Content.id = '';
      buildYourOwnStep4.innerHTML = step4Content.innerHTML;
      buildYourOwnStep4.style.display = 'block';

    }

    const headerEl = widget.querySelector('.recharge-widget__header');
    const optionsEl = widget.querySelector('.recharge-widget__options');
    if (headerEl && optionsEl && buildYourOwnSubscriptionOptions) {
      buildYourOwnSubscriptionOptions.innerHTML = headerEl.outerHTML + optionsEl.outerHTML;
      buildYourOwnSubscriptionOptions.style.display = 'block';

      const copiedOptionsEl = buildYourOwnSubscriptionOptions.querySelector('.recharge-widget__options');
      if (copiedOptionsEl) {
        copiedOptionsEl.style.display = 'grid';
        copiedOptionsEl.style.gridTemplateColumns = 'repeat(auto-fit, minmax(180px, 1fr))';
        copiedOptionsEl.style.gap = '1rem';

      }

      let checkedRadio = buildYourOwnSubscriptionOptions.querySelector('.recharge-option__radio:checked');

      if (!checkedRadio) {
        const firstRadio = buildYourOwnSubscriptionOptions.querySelector('.recharge-option__radio');
        if (firstRadio) {
          firstRadio.checked = true;
          checkedRadio = firstRadio;
          const firstOption = firstRadio.closest('.recharge-option');
          if (firstOption) {
            buildYourOwnSubscriptionOptions.querySelectorAll('.recharge-option').forEach(opt => {
              opt.classList.remove('is-selected');
            });
            firstOption.classList.add('is-selected');
          }
          const isOneTime = firstOption?.dataset.optionType === 'onetime';

          const byoWidget = getCurrentByoWidget();
          const originalWidget = byoWidget ? byoWidget.querySelector('.recharge-widget') : null;
          if (originalWidget) {
            if (isOneTime) {
              const originalOneTime = originalWidget.querySelector('.recharge-option[data-option-type="onetime"] .recharge-option__radio');
              if (originalOneTime && !originalOneTime.checked) {
                originalOneTime.checked = true;
                const originalOption = originalOneTime.closest('.recharge-option');
                if (originalOption) {
                  originalWidget.querySelectorAll('.recharge-option').forEach(opt => {
                    opt.classList.remove('is-selected');
                  });
                  originalOption.classList.add('is-selected');
                }
              }
            } else {
              const originalRadio = originalWidget.querySelector(`.recharge-option__radio[value="${firstRadio.value}"]`);
              if (originalRadio && !originalRadio.checked) {
                originalRadio.checked = true;
                const originalOption = originalRadio.closest('.recharge-option');
                if (originalOption) {
                  originalWidget.querySelectorAll('.recharge-option').forEach(opt => {
                    opt.classList.remove('is-selected');
                  });
                  originalOption.classList.add('is-selected');
                }
              }
            }
          }
        }
      }

      if (checkedRadio) {
        const parentLabel = checkedRadio.closest('.recharge-option');
        if (parentLabel) {
          buildYourOwnSubscriptionOptions.querySelectorAll('.recharge-option').forEach(opt => {
            opt.classList.remove('is-selected');
          });
          parentLabel.classList.add('is-selected');
        }
      }

      setTimeout(() => {
        updateVisualState(buildYourOwnSubscriptionOptions);

      }, 50);
    }

    setTimeout(function() {
      if (window.initializeRechargeWidgets) {
        window.initializeRechargeWidgets();
      }
      bindBuildYourOwnEvents();

      setTimeout(() => {
        updateVisualState(buildYourOwnVariantOptions);
        updateVisualState(buildYourOwnSubscriptionOptions);

      }, 100);
    }, 100);
  }

  function bindBuildYourOwnEvents() {
    const bundleComponent = document.querySelector('choose-collection-products');
    if (!bundleComponent) {
      return;
    }

    const byoWidgetContainer = getCurrentByoWidget();
    const originalWidget = byoWidgetContainer ? byoWidgetContainer.querySelector('.recharge-widget') : null;
    let productVariants = [];
    if (originalWidget) {
      // Update bundleProductId to match the BYO widget's product
      if (originalWidget.dataset.productId) {
        bundleComponent.dataset.bundleProductId = originalWidget.dataset.productId;
      }
      
      const variantOptionsEl = originalWidget.querySelector('.recharge-widget__variant-options');
      if (variantOptionsEl && variantOptionsEl.dataset.productVariants) {
        try {
          productVariants = JSON.parse(variantOptionsEl.dataset.productVariants);
        } catch (e) {
        }
      }
    }

    const selectedOptions = {};

    buildYourOwnVariantOptions.querySelectorAll('.recharge-option-value__radio:checked').forEach(radio => {
      selectedOptions[radio.dataset.optionPosition] = radio.value;
    });

    function findMatchingVariant() {
      const matchingVariant = productVariants.find(variant => {
        return Object.entries(selectedOptions).every(([pos, val]) => {
          return variant[`option${pos}`] === val;
        });
      });
      return matchingVariant;
    }

    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
      const dollars = (cents / 100).toFixed(2);
      return '$' + dollars;
    }

    function updateBYOOneTimePrice(variant) {
      if (!variant || !buildYourOwnSubscriptionOptions) return;

      const oneTimeOption = buildYourOwnSubscriptionOptions.querySelector('.recharge-option[data-option-type="onetime"]');
      if (!oneTimeOption) return;

      const priceElement = oneTimeOption.querySelector('.recharge-option__price');
      if (priceElement) {
        priceElement.textContent = formatMoney(variant.price);
      }
    }

    function updateBYOSubscriptionPrices(variant) {
      if (!variant || !buildYourOwnSubscriptionOptions) return;

      const subscriptionDiscount = 0.10;
      const basePrice = variant.price;
      const discountedPrice = Math.round(basePrice * (1 - subscriptionDiscount));

      buildYourOwnSubscriptionOptions.querySelectorAll('.recharge-option[data-option-type="subscription"]').forEach(option => {
        const pricingDiv = option.querySelector('.recharge-option__pricing');
        if (!pricingDiv) return;

        const priceElement = pricingDiv.querySelector('.recharge-option__price--sale') ||
                            pricingDiv.querySelector('.recharge-option__price');
        const comparePriceElement = pricingDiv.querySelector('.recharge-option__price--compare');

        if (priceElement) {
          priceElement.textContent = formatMoney(discountedPrice);
        }

        if (comparePriceElement) {
          comparePriceElement.textContent = formatMoney(basePrice);
        } else if (basePrice > discountedPrice) {
          pricingDiv.innerHTML = `
            <span class="recharge-option__price--sale">${formatMoney(discountedPrice)}</span>
            <span class="recharge-option__price--compare">${formatMoney(basePrice)}</span>
          `;
        } else {
          pricingDiv.innerHTML = `<span class="recharge-option__price">${formatMoney(discountedPrice)}</span>`;
        }
      });
    }

    const initialVariant = findMatchingVariant();
    if (initialVariant) {
      bundleComponent.dataset.bundleVariantId = initialVariant.id;
      const variantPriceCents = Number(initialVariant.price) || 0;
      if (variantPriceCents > 0) {
        bundleComponent.dataset.bundlePriceCents = variantPriceCents;
      }
      updateBYOOneTimePrice(initialVariant);
      updateBYOSubscriptionPrices(initialVariant);
      
      // Update max items from variant for BYO mode only if collection has BYO Bundle Product
      if (bundleComponent.updateMaxFromVariant && hasByoBundleProductForCollection(currentCollectionHandle)) {
        bundleComponent.updateMaxFromVariant(initialVariant);
      }
    }

    let checkedSellingPlan = buildYourOwnSubscriptionOptions.querySelector('.recharge-option__radio:checked');

    if (!checkedSellingPlan) {
      const firstRadio = buildYourOwnSubscriptionOptions.querySelector('.recharge-option__radio');
      if (firstRadio) {
        firstRadio.checked = true;
        checkedSellingPlan = firstRadio;
        const firstOption = firstRadio.closest('.recharge-option');
        if (firstOption) {
          firstOption.classList.add('is-selected');
          buildYourOwnSubscriptionOptions.querySelectorAll('.recharge-option').forEach(opt => {
            if (opt !== firstOption) {
              opt.classList.remove('is-selected');
            }
          });
        }
      }
    }

    if (checkedSellingPlan) {
      bundleComponent.sellingPlanId = checkedSellingPlan.value || '';
      const optionElement = checkedSellingPlan.closest('.recharge-option');

      if (optionElement) {
        const priceCents = getPriceFromSelectedOption(optionElement);
        if (priceCents > 0) {
          bundleComponent.dataset.bundlePriceCents = priceCents;
        }
      }
    }

    if (bundleComponent.refresh) {
      bundleComponent.refresh();
    }

    function updateBYOOneTimePrice(variant) {
      if (!variant || !buildYourOwnSubscriptionOptions) return;

      const oneTimeOption = buildYourOwnSubscriptionOptions.querySelector('.recharge-option[data-option-type="onetime"]');
      if (!oneTimeOption) return;

      const priceElement = oneTimeOption.querySelector('.recharge-option__price');
      if (priceElement) {
        const formatMoney = (cents) => {
          if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
            return Shopify.formatMoney(cents);
          }
          const dollars = (cents / 100).toFixed(2);
          return '$' + dollars;
        };
        priceElement.textContent = formatMoney(variant.price);
      }
    }

    function updateBYOSubscriptionPrices(variant) {
      if (!variant || !buildYourOwnSubscriptionOptions) return;

      const subscriptionDiscount = 0.10;
      const basePrice = variant.price;
      const discountedPrice = Math.round(basePrice * (1 - subscriptionDiscount));

      const formatMoney = (cents) => {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          return Shopify.formatMoney(cents);
        }
        const dollars = (cents / 100).toFixed(2);
        return '$' + dollars;
      };

      buildYourOwnSubscriptionOptions.querySelectorAll('.recharge-option[data-option-type="subscription"]').forEach(option => {
        const pricingDiv = option.querySelector('.recharge-option__pricing');
        if (!pricingDiv) return;

        const priceElement = pricingDiv.querySelector('.recharge-option__price--sale') ||
                            pricingDiv.querySelector('.recharge-option__price');
        const comparePriceElement = pricingDiv.querySelector('.recharge-option__price--compare');

        if (priceElement) {
          priceElement.textContent = formatMoney(discountedPrice);
        }

        if (comparePriceElement) {
          comparePriceElement.textContent = formatMoney(basePrice);
        } else if (basePrice > discountedPrice) {
          pricingDiv.innerHTML = `
            <span class="recharge-option__price--sale">${formatMoney(discountedPrice)}</span>
            <span class="recharge-option__price--compare">${formatMoney(basePrice)}</span>
          `;
        } else {
          pricingDiv.innerHTML = `<span class="recharge-option__price">${formatMoney(discountedPrice)}</span>`;
        }
      });
    }

    buildYourOwnVariantOptions.querySelectorAll('.recharge-option-value__radio').forEach(radio => {
      radio.addEventListener('change', function() {
        const position = this.dataset.optionPosition;
        const value = this.value;

        selectedOptions[position] = value;

        updateVisualState(buildYourOwnVariantOptions);

        const matchingVariant = findMatchingVariant();
        if (matchingVariant) {
          const currentSellingPlanId = bundleComponent.sellingPlanId || '';

          bundleComponent.dataset.bundleVariantId = matchingVariant.id;

          const variantPriceCents = Number(matchingVariant.price) || 0;
          if (variantPriceCents > 0) {
            bundleComponent.dataset.bundlePriceCents = variantPriceCents;
          }

          updateBYOOneTimePrice(matchingVariant);
          updateBYOSubscriptionPrices(matchingVariant);
          
          // Update max items from variant for BYO mode only if collection has BYO Bundle Product
          if (bundleComponent.updateMaxFromVariant && hasByoBundleProductForCollection(currentCollectionHandle)) {
            bundleComponent.updateMaxFromVariant(matchingVariant);
          }

          if (currentSellingPlanId && buildYourOwnSubscriptionOptions) {
            const currentRadio = buildYourOwnSubscriptionOptions.querySelector(`.recharge-option__radio[value="${currentSellingPlanId}"]`);
            if (currentRadio && !currentRadio.checked) {
              currentRadio.checked = true;
              const currentOption = currentRadio.closest('.recharge-option');
              if (currentOption) {
                buildYourOwnSubscriptionOptions.querySelectorAll('.recharge-option').forEach(opt => {
                  opt.classList.remove('is-selected');
                });
                currentOption.classList.add('is-selected');
              }
            }
            bundleComponent.sellingPlanId = currentSellingPlanId;
          }

          bundleComponent.dispatchEvent(new Event('change', { bubbles: true }));
          if (bundleComponent.refresh) {
            bundleComponent.refresh();
          }
        }
      });
    });

    buildYourOwnSubscriptionOptions.querySelectorAll('.recharge-option').forEach(optionLabel => {
      const radio = optionLabel.querySelector('.recharge-option__radio');
      if (!radio) return;

      const handleSelection = (e) => {
        buildYourOwnSubscriptionOptions.querySelectorAll('.recharge-option').forEach(opt => {
          opt.classList.remove('is-selected');

        });

        optionLabel.classList.add('is-selected');
        if (!radio.checked) {
          radio.checked = true;
        }

        const byoWidget = getCurrentByoWidget();
        const originalWidget = byoWidget ? byoWidget.querySelector('.recharge-widget') : null;
        if (originalWidget) {
          const originalRadio = originalWidget.querySelector(`.recharge-option__radio[value="${radio.value}"]`);
          if (originalRadio && !originalRadio.checked) {

            originalRadio.click();
          }
        }

        if (bundleComponent) {
          bundleComponent.sellingPlanId = radio.value || '';

          const priceCents = getPriceFromSelectedOption(optionLabel);
          if (priceCents > 0) {
            bundleComponent.dataset.bundlePriceCents = priceCents;
          }

          bundleComponent.dispatchEvent(new Event('change', { bubbles: true }));
          if (bundleComponent.refresh) {
            bundleComponent.refresh();
          }
        }
      };

      optionLabel.addEventListener('click', handleSelection);
      radio.addEventListener('change', handleSelection);
    });
  }

  function insertStep4IntoWidget(widgetElement) {
    const step4Template = document.getElementById('step-4-template');
    if (!step4Template) return;

    if (widgetElement.querySelector('.step--inside-widget')) return;

    const variantOptions = widgetElement.querySelector('.recharge-widget__variant-options');
    const header = widgetElement.querySelector('.recharge-widget__header');

    if (variantOptions && header) {
      const step4Content = step4Template.cloneNode(true);
      step4Content.style.display = 'block';
      step4Content.id = '';

      header.parentNode.insertBefore(step4Content.firstElementChild, header);

    }
  }

  function hideBuildYourOwnOptions() {
    if (buildYourOwnVariantOptions) {
      buildYourOwnVariantOptions.style.display = 'none';
      buildYourOwnVariantOptions.innerHTML = '';
    }
    if (buildYourOwnStep4) {
      buildYourOwnStep4.style.display = 'none';
      buildYourOwnStep4.innerHTML = '';
    }
    if (buildYourOwnSubscriptionOptions) {
      buildYourOwnSubscriptionOptions.style.display = 'none';
      buildYourOwnSubscriptionOptions.innerHTML = '';
    }
  }

  function extractPriceFromText(priceText) {
    if (!priceText) return 0;
    const cleaned = priceText.replace(/[^0-9.,]/g, '').replace(',', '');
    const dollars = parseFloat(cleaned);
    return Math.round(dollars * 100);
  }

  function getPriceFromSelectedOption(optionElement) {
    const priceEl = optionElement.querySelector('.recharge-option__price--sale') ||
                     optionElement.querySelector('.recharge-option__price');
    if (priceEl) {
      return extractPriceFromText(priceEl.textContent);
    }
    return 0;
  }

  function getVariantPriceFromWidget(widgetEl) {
    const variantOptionsEl = widgetEl.querySelector('.recharge-widget__variant-options');
    if (!variantOptionsEl || !variantOptionsEl.dataset.productVariants) return 0;

    try {
      const productVariants = JSON.parse(variantOptionsEl.dataset.productVariants);
      const currentVariantId = widgetEl.dataset.variantId;
      if (currentVariantId) {
        const variant = productVariants.find(v => String(v.id) === String(currentVariantId));
        if (variant) {
          return Number(variant.price) || 0;
        }
      }
    } catch (e) {
    }
    return 0;
  }

  function updateBundlePrice(widgetEl, bundleComponent) {
    const mode = bundleComponent.dataset.mode || 'fixed';

    if (mode === 'fixed' && bundleComponent.fixedProduct) {
      const selectedOption = widgetEl.querySelector('.recharge-option__radio:checked');
      let priceCents = 0;

      if (selectedOption) {
        const optionElement = selectedOption.closest('.recharge-option');
        if (optionElement) {
          priceCents = getPriceFromSelectedOption(optionElement);
        }
      }

      if (priceCents === 0) {
        priceCents = getVariantPriceFromWidget(widgetEl);
      }

      if (priceCents > 0) {
        bundleComponent.fixedProduct.priceCents = priceCents;
        bundleComponent.dataset.bundlePriceCents = priceCents;
      }
    }
  }

  function bindWidgetEvents(widgetEl, bundleComponent) {
    if (!widgetEl || !bundleComponent) return;

    widgetEl.querySelectorAll('.recharge-option__radio').forEach(radio => {
      if (!radio.dataset.listenerBound) {
        radio.dataset.listenerBound = 'true';
        radio.addEventListener('change', function() {
          bundleComponent.sellingPlanId = this.value || '';

          updateBundlePrice(widgetEl, bundleComponent);

          if (bundleComponent.refresh) {
            bundleComponent.refresh();
          }
        });
      }
    });

    widgetEl.querySelectorAll('.recharge-option-value__radio').forEach(radio => {
      if (!radio.dataset.listenerBound) {
        radio.dataset.listenerBound = 'true';
        radio.addEventListener('change', function() {

          setTimeout(() => {
            const newVariantId = widgetEl.dataset.variantId;
            if (newVariantId) {
              bundleComponent.dataset.bundleVariantId = newVariantId;

              updateBundlePrice(widgetEl, bundleComponent);

              if (bundleComponent.refresh) {
                bundleComponent.refresh();
              }
            }
          }, 200);
        });
      }
    });
  }

  function showGridForCollection(collectionHandle) {

    currentCollectionHandle = collectionHandle;

    // Reset max to default if switching to collection without BYO Bundle Product
    const bundleComponent = document.querySelector('choose-collection-products');
    if (bundleComponent) {
      const mode = bundleComponent.dataset.mode || 'fixed';
      if (mode === 'build-your-own' && !hasByoBundleProductForCollection(collectionHandle)) {
        if (bundleComponent.defaultMax !== undefined) {
          bundleComponent.max = bundleComponent.defaultMax;
          bundleComponent.dataset.max = String(bundleComponent.defaultMax);
          if (bundleComponent.refresh) {
            bundleComponent.refresh();
          }
        }
      }
    }

    updateFilterTabs(collectionHandle);

    const hasFilters = window.collectionFilters && window.collectionFilters[collectionHandle];

    if (hasFilters && hasFilters.length > 0) {
      const firstFilterValue = hasFilters[0];
      currentFilterValue = firstFilterValue;
      showGridForCollectionAndFilter(collectionHandle, firstFilterValue);
    } else {
      fixedProductsGrids.forEach(grid => {
        grid.style.display = 'none';
        grid.classList.remove('active');
      });

      const activeGrid = document.querySelector(
        `.fixed-products-grid[data-collection-handle="${collectionHandle}"]:not([data-filter-value])`
      );
      if (activeGrid) {
        activeGrid.style.display = 'flex';
        activeGrid.classList.add('active');

        attachCardClickEvents(activeGrid);

        const firstCard = activeGrid.querySelector('.fixed-product-card');
        if (firstCard) {
          firstCard.click();
        }
      }
    }
  }

  function attachCardClickEvents(grid) {
    const cards = grid.querySelectorAll('.fixed-product-card');

    cards.forEach(card => {
      const newCard = card.cloneNode(true);
      card.parentNode.replaceChild(newCard, card);
    });

    const newCards = grid.querySelectorAll('.fixed-product-card');
    newCards.forEach(card => {
      card.addEventListener('click', function() {
        const productType = this.dataset.productType;
        const productIndex = this.dataset.productIndex;

        newCards.forEach(c => c.classList.remove('active'));
        this.classList.add('active');

        const allWidgets = document.querySelectorAll('.fixed-product-widget-container');
        allWidgets.forEach(w => {
          if (w.closest('#fixed-product-widget-display')) {
            return;
          }
          w.style.display = 'none';
        });

        if (productType === 'fixed') {
          hideBuildYourOwnOptions();

          const cardFilterValue = this.dataset.filterValue || currentFilterValue;
          const cardProductId = this.dataset.productId;
          const cardProductIndex = this.dataset.productIndex;

          const allWidgetContainers = document.querySelectorAll('.fixed-product-widget-container:not(#current-page-product-widget):not(.byo-alternative-widget)');

          let widget = null;

          if (cardProductId && currentCollectionHandle) {
            if (cardFilterValue) {
              widget = Array.from(allWidgetContainers).find(w => {
                const matchesCollection = w.dataset.collectionHandle === currentCollectionHandle;
                const matchesProduct = w.dataset.productId === cardProductId;
                const matchesFilter = w.dataset.filterValue === cardFilterValue;
                return matchesCollection && matchesProduct && matchesFilter;
              });
            }

            if (!widget) {
              widget = Array.from(allWidgetContainers).find(w => {
                const matchesCollection = w.dataset.collectionHandle === currentCollectionHandle;
                const matchesProduct = w.dataset.productId === cardProductId;
                return matchesCollection && matchesProduct;
              });
            }
          }

          if (!widget && cardProductIndex !== undefined && currentCollectionHandle) {
            widget = Array.from(allWidgetContainers).find(w => {
              const matchesCollection = w.dataset.collectionHandle === currentCollectionHandle;
              const matchesIndex = w.dataset.productIndex === cardProductIndex;
              return matchesCollection && matchesIndex;
            });
          }

          if (widget) {
            const displayContainer = document.getElementById('fixed-product-widget-display');
            if (displayContainer) {
              const existingWidget = displayContainer.querySelector('.fixed-product-widget-container');
              if (existingWidget && existingWidget !== widget) {
                existingWidget.style.display = 'none';
                const originalParent = existingWidget._originalParent;
                if (originalParent && originalParent.nodeType === 1) {
                  try {
                    displayContainer.removeChild(existingWidget);
                    originalParent.appendChild(existingWidget);
                    existingWidget._originalParent = null;
                  } catch (e) {
                    displayContainer.removeChild(existingWidget);
                  }
                } else {
                  displayContainer.removeChild(existingWidget);
                }
              }

              if (widget.parentNode !== displayContainer) {
                if (!widget._originalParent && widget.parentNode) {
                  widget._originalParent = widget.parentNode;
                }

                if (widget.parentNode) {
                  widget.parentNode.removeChild(widget);
                }
                displayContainer.appendChild(widget);
              }

              displayContainer.style.display = 'block';
              widget.style.display = 'block';

              const widgetEl = widget.querySelector('.recharge-widget');
              if (widgetEl) {
                insertStep4IntoWidget(widgetEl);
              }
            }

            const bundleComponent = document.querySelector('choose-collection-products');
            if (bundleComponent) {
              const widgetEl = widget.querySelector('.recharge-widget');
              if (widgetEl) {
                const productId = widgetEl.dataset.productId;
                const variantId = widgetEl.dataset.variantId;

                if (variantId) {
                  bundleComponent.dataset.mode = 'fixed';
                  if (productId) {
                    bundleComponent.dataset.bundleProductId = productId;
                  }
                  bundleComponent.dataset.bundleVariantId = variantId;

                  bundleComponent.bundleSelections.clear();

                  bundleComponent.querySelectorAll('.item--product').forEach(product => {
                    const input = product.querySelector('input[name="qty"]');
                    if (input) {
                      input.value = 0;
                    }
                    product.dataset.qty = '0';
                    product.classList.add('not-active');
                  });

                  const productTitle = this.querySelector('.name__heading-collection')?.textContent?.trim() || 'Product';
                  const productImage = this.querySelector('.image-col')?.src || '';
                  const productPriceCents = Number(this.dataset.productPrice || 0);

                  bundleComponent.fixedProduct = {
                    title: productTitle,
                    image: productImage,
                    qty: 1,
                    priceCents: productPriceCents
                  };
                  bundleComponent.dataset.bundlePriceCents = productPriceCents;
                  const checkedPlan = widgetEl.querySelector('.recharge-option__radio:checked');
                  if (checkedPlan) {
                    bundleComponent.sellingPlanId = checkedPlan.value || '';
                  } else {
                    bundleComponent.sellingPlanId = '';
                  }

                  updateBundlePrice(widgetEl, bundleComponent);

                  if (bundleComponent.refresh) {
                    bundleComponent.refresh();
                  }

                  bindWidgetEvents(widgetEl, bundleComponent);
                }
              }
            }

            setTimeout(function() {
              const widgetElement = widget.querySelector('.recharge-widget');

              if (window.initializeRechargeWidgets && widgetElement) {
                window.initializeRechargeWidgets();
              }

              const bundleComp = document.querySelector('choose-collection-products');
              if (bundleComp && widgetElement) {
                bindWidgetEvents(widgetElement, bundleComp);

                const variantId = widgetElement.dataset.variantId;
                if (variantId) {
                  if (bundleComp.dataset.bundleVariantId !== variantId) {
                    bundleComp.dataset.bundleVariantId = variantId;
                  }

                  const checkedPlan = widgetElement.querySelector('.recharge-option__radio:checked');
                  if (checkedPlan && bundleComp.sellingPlanId !== checkedPlan.value) {
                    bundleComp.sellingPlanId = checkedPlan.value || '';
                  }

                  updateBundlePrice(widgetElement, bundleComp);

                  if (bundleComp.refresh) {
                    bundleComp.refresh();
                  }
                }
              }
            }, 300);
          }

          if (productsTabsContainer) {
            productsTabsContainer.style.display = 'none';
          }
        } else if (productType === 'custom') {
          const bundleComponent = document.querySelector('choose-collection-products');
          if (bundleComponent) {
            bundleComponent.dataset.mode = 'build-your-own';
            bundleComponent.fixedProduct = null;

            // Reset max to default if collection doesn't have BYO Bundle Product
            if (!hasByoBundleProductForCollection(currentCollectionHandle)) {
              if (bundleComponent.defaultMax !== undefined) {
                bundleComponent.max = bundleComponent.defaultMax;
                bundleComponent.dataset.max = String(bundleComponent.defaultMax);
              }
            }

            if (bundleComponent.refresh) {
              bundleComponent.refresh();
            }
          }

          showBuildYourOwnOptions();

          setTimeout(() => {
            const buildYourOwnSubscriptionOptions = document.getElementById('build-your-own-subscription-options');
            if (buildYourOwnSubscriptionOptions && bundleComponent) {
              const checkedRadio = buildYourOwnSubscriptionOptions.querySelector('.recharge-option__radio:checked');
              if (!checkedRadio) {
                const firstRadio = buildYourOwnSubscriptionOptions.querySelector('.recharge-option__radio');
                if (firstRadio) {
                  firstRadio.checked = true;
                  bundleComponent.sellingPlanId = firstRadio.value || '';
                  const firstOption = firstRadio.closest('.recharge-option');
                  if (firstOption) {
                    buildYourOwnSubscriptionOptions.querySelectorAll('.recharge-option').forEach(opt => {
                      opt.classList.remove('is-selected');
                    });
                    firstOption.classList.add('is-selected');
                  }
                }
              } else {
                bundleComponent.sellingPlanId = checkedRadio.value || '';
              }
            }
          }, 200);

          if (productsTabsContainer) {
            productsTabsContainer.style.display = 'block';
          }
        }
      });
    });
  }

  collectionTabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const collectionHandle = this.dataset.id;

      collectionTabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');

      showGridForCollection(collectionHandle);

      const allTabs = document.querySelectorAll('.item--collection--tab-parent');
      allTabs.forEach(t => t.classList.remove('active'));
      const activeTab = document.querySelector(`.item--collection--tab-parent[data-id="${collectionHandle}"]`);
      if (activeTab) {
        activeTab.classList.add('active');
      }
    });
  });

  if (collectionTabs[0]) {
    const firstHandle = collectionTabs[0].dataset.id;
    showGridForCollection(firstHandle);
  }

  setTimeout(function() {
    if (window.initializeRechargeWidgets) {
      window.initializeRechargeWidgets();
    }
  }, 100);
});

